import crypto from "crypto-js";
import $ from "jquery";
require("dotenv").config();
const BaseUri = process.env.REACT_APP_BACKEND_URI;
const roundTimes = 10;
const stretchingTimes = 2 ** roundTimes;
const customersMemosTimeoutMillisec = 1000 * 60 * 5;

const hashWithSalt = (plainTxt, rawSalt) => {
  const salt = crypto.SHA256(rawSalt);
  let hashedTxt = crypto.SHA256(plainTxt + salt);
  for (let round = 0; round < stretchingTimes; round++) {
    hashedTxt = crypto.SHA256(hashedTxt + salt);
  }
  return hashedTxt;
};

export const fetchCustomerInfo = (branchCode, accountNumber, cifNumber) => {
  const whichSearchUsed = accountNumber
    ? `${BaseUri}/customers/search?branch_code=${branchCode}&account_number=${accountNumber}`
    : `${BaseUri}/customers/search?branch_code=${branchCode}&cif_number=${cifNumber}`;

  return $.ajax({
    type: "GET",
    url: whichSearchUsed,
    jsonp: "callback",
    dataType: "jsonp",
  });
};

export const fetchCustomerMemosCount = (branchCode, accountNumber) => {
  return $.ajax({
    type: "GET",
    url: `${BaseUri}/customers/memos/count?branch_code=${branchCode}&account_number=${accountNumber}`,
    jsonp: "callback",
    dataType: "jsonp",
    timeout: customersMemosTimeoutMillisec,
  });
};

export const deleteCustomerMemos = (branchCode, accountNumber) => {
  //FIXME: 本来であれば、deleteメソッドにしてリクエストするべきだが、JSONPの仕様上GETしか指定できない
  //そのため、deleteURLに対してGETを行い、クエリパラメータで情報を付与する。
  return $.ajax({
    type: "GET",
    url: `${BaseUri}/customers/memos/delete?branch_code=${branchCode}&account_number=${accountNumber}`,
    jsonp: "callback",
    dataType: "jsonp",
    timeout: customersMemosTimeoutMillisec,
  });
};

export const authentication = (id, password) => {
  const hashed = hashWithSalt(password, id);

  const authorization = `Basic ${id}:${hashed}`;

  return $.ajax({
    type: "GET",
    url: `${BaseUri}/authentication?authorization=${authorization}`,
    jsonp: "callback",
    dataType: "jsonp",
  });
};

export const updatePasswordRequest = (oldPassword, newPassword, accountId) => {
  const hashedOldPass = hashWithSalt(oldPassword, accountId);
  const hashedNewPass = hashWithSalt(newPassword, accountId);

  return $.ajax({
    type: "GET",
    url: `${BaseUri}/authentication/reset?oldPassword=${hashedOldPass}&newPassword=${hashedNewPass}`,
    jsonp: "callback",
    dataType: "jsonp",
  });
};

export const fetchCustomerHistories = (appIds, span) => {
  const query =
    appIds.length === 1
      ? `${appIds}&applicationids=ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ`
      : appIds.join("&applicationids=");
  return $.ajax({
    type: "GET",
    url: `${BaseUri}/customers/histories?applicationids=${query}${
      !span ? "" : `&span=${span}`
    }`,
    jsonp: "callback",
    dataType: "jsonp",
  });
};

export const registerInherit = async (param) => {
  return $.ajax({
    type: "GET",
    url: `${BaseUri}/inherit/account?branch_code=${param.branchCode}&account_number=${param.accountNumber}&cif_number=${param.cifNumber}&is_inherit=${param.isInherit}`,
    jsonp: "callback",
    dataType: "jsonp",
  }).then((response) => {
    if (response.system_message) {
      return response;
    }

    const { inherit_id: inheritId } = response;
    if (!inheritId) return;

    return $.ajax({
      type: "GET",
      url: `${BaseUri}/inherit/account/status?inherit_id=${inheritId}&is_inherit=${param.isInherit}`,
      jsonp: "callback",
      dataType: "jsonp",
    });
  });
};

export const registerProhibit = async (param = {}) => {
  return $.ajax({
    type: "GET",
    url: `${BaseUri}/prohibit/account?branch_code=${param.branchCode}&account_number=${param.accountNumber}&cif_number=${param.cifNumber}&is_prohibit=${param.isProhibit}`,
    jsonp: "callback",
    dataType: "jsonp",
  }).then((response) => {
    if (response.system_message) {
      return response;
    }

    const { prohibit_id: prohibitId } = response;
    if (!prohibitId) return;

    return $.ajax({
      type: "GET",
      url: `${BaseUri}/prohibit/account/status?prohibit_id=${prohibitId}&is_prohibit=${param.isProhibit}`,
      jsonp: "callback",
      dataType: "jsonp",
    });
  });
};
